"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  colors: true,
  colorClasses: true,
  opensans: true,
  poppins: true,
  colorOptions: true,
  colorMappings: true,
  breakpoints: true,
  constants: true,
  weights: true,
  MaterialTheme: true,
  Breakpoints: true
};
Object.defineProperty(exports, "Breakpoints", {
  enumerable: true,
  get: function get() {
    return _breakpoints.default;
  }
});
Object.defineProperty(exports, "MaterialTheme", {
  enumerable: true,
  get: function get() {
    return _materialTheme.default;
  }
});
Object.defineProperty(exports, "breakpoints", {
  enumerable: true,
  get: function get() {
    return constants.breakpoints;
  }
});
exports.colorClasses = void 0;
Object.defineProperty(exports, "colorMappings", {
  enumerable: true,
  get: function get() {
    return constants.colorMappings;
  }
});
Object.defineProperty(exports, "colorOptions", {
  enumerable: true,
  get: function get() {
    return constants.colorOptions;
  }
});
exports.weights = exports.poppins = exports.opensans = exports.constants = exports.colors = void 0;
var colors = _interopRequireWildcard(require("./shared/colors"));
exports.colors = colors;
var colorClasses = _interopRequireWildcard(require("./shared/color-classes"));
exports.colorClasses = colorClasses;
var opensans = _interopRequireWildcard(require("./shared/open-sans"));
exports.opensans = opensans;
var poppins = _interopRequireWildcard(require("./shared/poppins"));
exports.poppins = poppins;
var constants = _interopRequireWildcard(require("./shared/constants"));
exports.constants = constants;
var weights = _interopRequireWildcard(require("./shared/font-weights"));
exports.weights = weights;
var _globals = require("./shared/globals");
Object.keys(_globals).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _globals[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _globals[key];
    }
  });
});
var _materialTheme = _interopRequireDefault(require("./constants/material-theme"));
var _breakpoints = _interopRequireDefault(require("./constants/breakpoints"));